import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { login } from '../helpers/methods'
import { version } from '../../package.json';
import { TOKEN_KEY, TOKEN_DATE } from '../store/auth';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPublic } from '../store/auth';

//LAYOUT
import PublicLayout from '../layouts/public';

//COMPONENTS
import {Logo} from '../components/inspinia'
import PublicButton from '../components/publicButton';
import PublicInput from '../components/publicInput';

class Login extends React.PureComponent
{
    constructor(props)
    {
        super(props);

        this.state = {
            user: { email: '', password: '' },
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem("@mosaite-token@");
        localStorage.removeItem("@mosaite-date@");

        if (this.props.actions?.auth?.logoutFinished) {
            this.props.actions.auth.logoutFinished();
        }

        if (this.props.location?.state?.senhaRedefinida) {
            c.TOASTER_SUCCESS("Senha redefinida com sucesso. Faça login novamente.");
        }

        if (this.props.location?.state?.senhaRecuperada) {
            c.TOASTER_SUCCESS(this.props.location.state.mensagem);
        }
    }
       
    handleChange(e)
    {
        const user = this.state.user;

        this.setState({ user: { ...user, [e.target.name]: e.target.value } });
    }

    handleLogin = (e) => {
        e.preventDefault();
        if (this.state.loading) return;

        const { email, password } = this.state.user;
        if (!email || !password) {
            c.TOASTER_ERROR("Favor preencher usuário e senha.");
            return;
        }

        this.setState({ loading: true });
        login(this.props, this.state.user)
            .finally(() => this.setState({ loading: false }));
    }

    render()
    {
        const user = this.state.user;

        return (
            <PublicLayout>
                <div>
                    <div className="mb-4 text-center">
                        <Logo />
                    </div>
                
                    <div className="ibox-content text-center" style={{"width": "345px", "height": "372px", "padding": "39px 33px", "borderRadius": "10px", "boxShadow": "1px 3px 10px 0 rgba(0, 0, 0, 0.3)"}}>
                        <h3 className="mt-0 fs-20 text-body">
                            Bem-vindo!
                        </h3>
                        
                        <div className="mb-4" style={{display: "inline-block", width: "51px", height: "4px", backgroundColor: "#01bc8e"}}></div>
            
                        <form className="form-signin m-t" onSubmit={this.handleLogin}>
                            
                            <PublicInput type="email" name="email" placeholder="E-mail" value={user.email} onChange={this.handleChange} img="/assets/images/user-icon.svg" maxLength={64} />

                            <PublicInput type="password" name="password" placeholder="Senha" value={user.password} onChange={this.handleChange} img="/assets/images/password-icon.svg" maxLength={64}/>
                
                            <div className="clearfix mb-4">
                                <div className="float-left">
                                    
                                </div>

                                <div className="float-right">
                                    <Link to={'/recuperar-senha'}>
                                        <small className="fs-12" style={{color: "#01bc8e"}}>Recuperar senha</small>
                                    </Link>
                                </div>
                            </div>

                            <PublicButton type="submit" name="entrar">ENTRAR</PublicButton>
                            <div className="float-center mt-2">                       
                                {version}
                            </div>
                                    
                        </form>
                    </div>

                    <div className="mb-0 py-4 px-0 text-left">
                        <Link to={c.DEFAULT_PUBLIC_ROUTE} className="text-light" style={{visibility: "hidden"}}>
                            <i className="fa fa-long-arrow-left"></i> Voltar 
                        </Link>
                    </div>
                </div>
            </PublicLayout>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { auth: bindActionCreators(authActionPublic, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
